import FirestoreDocument from "../../../types/FirestoreDocument";
import { any, array, boolean, nullable, object, string, timestamp } from "../../../types/_types";

import { UserRef } from "../../users/types/User";

export const Todo = FirestoreDocument.extend({
	type: string(),
	createdAt: timestamp(),
	organizationIds: array(string()),
	userIds: array(string()),
	users: array(UserRef),
	subjectRef: any(),
	content: any(),
	languages: array(string()),
	notification: boolean(),
	url: string(),
	pinned: object({
		status: boolean(),
		user: nullable(UserRef),
	}).default({
		status: false,
		user: null,
	}),
	resolved: object({
		status: boolean(),
		timestamp: nullable(timestamp()),
		user: nullable(UserRef),
	}).default({
		status: false,
		timestamp: null,
		user: null,
	}),
});
